import React, { useEffect, useState } from "react"
import { Link as PrismicLink } from "prismic-reactjs"
import { ChevronDown } from "@styled-icons/boxicons-regular/ChevronDown"

import { Element, Text } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import { PrismicNavigationDataBodyTopLevelItem } from "types/__generated__/gatsby-graphql"
import useBreakpoints from "src/legacy/hooks/useBreakpoints"

interface OwnProps {
  menuId: string
  openSubMenu?: string
  setOpenSubMenu: (openNav: string) => void
  subMenu: Maybe<PrismicNavigationDataBodyTopLevelItem>
}

export type SubMenuProps = OwnProps

const SubMenu: React.FC<SubMenuProps> = ({
  menuId,
  openSubMenu,
  setOpenSubMenu,
  subMenu,
}): React.ReactElement | null => {
  if (!subMenu?.items || !subMenu?.primary) return null
  const [isOpen, setIsOpen] = useState(false)
  const { breakpoint } = useBreakpoints()
  const {
    items,
    primary: { menu_name },
  } = subMenu
  const transform = `${isOpen ? "rotate(180deg)" : "rotate(0)"}`

  const handleClick = function (openState: boolean): void {
    const stateToSet = !openState

    if (stateToSet) {
      setOpenSubMenu(menuId)
    } else {
      setOpenSubMenu("")
    }

    setIsOpen(stateToSet)
  }

  useEffect(() => {
    if (openSubMenu !== menuId) {
      setIsOpen(false)
    }
  }, [openSubMenu])

  useEffect(() => {
    setIsOpen(false)
    setOpenSubMenu("")
  }, [breakpoint])

  return (
    <Element
      alignItems="center"
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      height="100%"
      mr={[0, 0, "0", "20"]}
      overflow={["hidden", "hidden", "hidden", "visible"]}
      position="relative"
      right="0"
      width={["100%", "100%", "100%", "auto"]}
    >
      <Text
        alignItems="center"
        as="p"
        cursor="pointer"
        display="flex"
        justifyContent="space-between"
        onClick={() => handleClick(isOpen)}
        py={[20, 20, 20, 0]}
        variant="navLink"
        width="100%"
      >
        {menu_name}
        <Element
          as="span"
          display={["inline", "inline", "inline", "none"]}
          style={{ transform }}
          transition="all 0.2s ease"
        >
          <ChevronDown size="18" />
        </Element>
      </Text>
      <Element
        as="ul"
        borderBottom={[
          "1SolidGrayLight",
          "1SolidGrayLight",
          "1SolidGrayLight",
          "none",
        ]}
        bg="white"
        maxHeight={isOpen ? "100vh" : 0}
        position={["relative", "relative", "relative", "absolute"]}
        overflow="hidden"
        top={["0", "0", "0", "50"]}
        transition="all 0.5s ease"
        width={["100%", "100%", "100%", "200px"]}
      >
        {items.map((item, index) => {
          if (!item?.link_url) return null

          const first = index === 0
          const last = index === items.length - 1
          const { link_text, link_url } = item

          return (
            <Element
              as="li"
              key={`menuItem_${index}`}
              mb={last ? "5" : 0}
              mt={first ? "5" : 0}
              py="10"
              px="10"
              width="100%"
            >
              <Link
                display="block"
                p="10"
                to={PrismicLink.url(link_url)}
                variant="navLink"
                width="100%"
              >
                {link_text}
              </Link>
            </Element>
          )
        })}
      </Element>
    </Element>
  )
}

export default SubMenu
